import React from 'react';
import { motion } from 'framer-motion';
import { Search, Palette, MessageCircle, HeartHandshake } from 'lucide-react';
const steps = [{
  icon: Search,
  color: 'bg-sadness',
  textColor: 'text-sadness',
  title: '1. Identifica / Identify',
  desc: 'Cuando veas que la emoción sube, invita al niño a buscar al monstruo que se parece a cómo se siente.'
}, {
  icon: Palette,
  color: 'bg-happiness',
  textColor: 'text-yellow-600',
  title: '2. Colorea / Color',
  desc: 'Deja que use los colores que él asocie con el sentimiento, no importa si son "correctos".'
}, {
  icon: MessageCircle,
  color: 'bg-fear',
  textColor: 'text-fear',
  title: '3. Nombra / Name',
  desc: 'Repite las palabras en ambos idiomas mientras él traza las letras.'
}, {
  icon: HeartHandshake,
  color: 'bg-calm',
  textColor: 'text-calm',
  title: '4. Valida / Validate',
  desc: 'Dile "Está bien sentir este fuego, vamos a darle un lugar aquí en el papel".'
}];
export const MethodSection = () => {
  return <section className="w-full py-24 px-6 bg-white" data-id="element-115">
      <div className="max-w-6xl mx-auto" data-id="element-116">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-117">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-dark mb-6" data-id="element-118">
            El Mecanismo Único:
            <br data-id="element-119" />
            <span className="text-calm" data-id="element-120">"Colorea, Nombra y Calma"</span>
          </h2>
          <p className="font-body text-lg text-dark/70 leading-relaxed" data-id="element-121">
            Este libro utiliza la neurociencia del arte. Al colorear, el cerebro
            del niño pasa del estado de "alerta" (amígdala) al estado de
            "enfoque" (corteza prefrontal). Al nombrar la emoción en inglés y
            español, fortalecemos las conexiones neuronales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-122">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex flex-col items-center text-center group" data-id="element-123">
              <div className={`w-20 h-20 rounded-2xl ${step.color} bg-opacity-20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`} data-id="element-124">
                <step.icon className={`w-10 h-10 ${step.textColor}`} data-id="element-125" />
              </div>
              <h3 className="font-display text-xl font-bold text-dark mb-3" data-id="element-126">
                {step.title}
              </h3>
              <p className="font-body text-dark/70" data-id="element-127">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};